/* eslint-disable @typescript-eslint/no-unused-vars */
import { pipelineFeature } from "./pipeline.reducer";
import { pipelineAdapter } from "./pipeline.state";

const entityAdapters = pipelineAdapter.getSelectors();
const { name, reducer, ...selectors } = pipelineFeature;

export const pipelineSelectors = {
  ...entityAdapters,
  ...selectors,
};